import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { RouterProvider } from "react-router-dom";
import root from "./router/root";
import { AUTH_EXPIRED_EVENT } from "./services/apiClient";
import { clearMember, fetchMeAsync } from "./slices/loginSlice";

function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    const handleAuthExpired = () => {
      dispatch(clearMember());
      alert("로그인 정보가 만료되었습니다. 다시 로그인해주세요.");

      if (window.location.pathname !== "/login") {
        window.location.replace("/login");
      }
    };

    window.addEventListener(AUTH_EXPIRED_EVENT, handleAuthExpired);

    return () => {
      window.removeEventListener(AUTH_EXPIRED_EVENT, handleAuthExpired);
    };
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchMeAsync());
  }, [dispatch]);

  return <RouterProvider router={root} />;
}

export default App;
